import React from "react";
import styles from "./Layout.module.scss";
import Sidebar from "../components/Sidebar";
import Transition from "../components/Transition";
import SEO from "./SEO";

const Layout = ({ children, location }) => (
  <div className={styles.layout}>
    <SEO />
    <Sidebar />
    <Transition location={location}>{children}</Transition>
  </div>
);

export default Layout;
